import { render, staticRenderFns } from "./FusionDebtors.vue?vue&type=template&id=7f92d22a&scoped=true"
import script from "./FusionDebtors.vue?vue&type=script&lang=js"
export * from "./FusionDebtors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f92d22a",
  null
  
)

export default component.exports